import { CompetencyTranslationFieldKind } from '@/constants/competencies/CompetencyTranslationFieldKind';

/**
 * Per-field-kind indentation and text styling for translation rows. Drives the
 * visual hierarchy (group → competency → question → option) of the translations list.
 */
export const COMPETENCY_TRANSLATION_FIELD_STYLE: Record<
    CompetencyTranslationFieldKind,
    { indent: string; text: string }
> = {
    [CompetencyTranslationFieldKind.GROUP_NAME]: { indent: '', text: 'font-semibold text-md' },
    [CompetencyTranslationFieldKind.GROUP_DESCRIPTION]: {
        indent: 'pl-1',
        text: 'text-base-500 italic text-md',
    },
    [CompetencyTranslationFieldKind.COMPETENCY_NAME]: {
        indent: 'pl-4',
        text: 'font-semibold text-md',
    },
    [CompetencyTranslationFieldKind.COMPETENCY_DESCRIPTION]: {
        indent: 'pl-5',
        text: 'text-base-500 italic text-md',
    },
    [CompetencyTranslationFieldKind.QUESTION_LABEL]: { indent: 'pl-6', text: 'text-md' },
    [CompetencyTranslationFieldKind.OPTION_LABEL]: {
        indent: 'pl-7 md:pl-12',
        text: 'text-base-500 text-md',
    },
};
